// Dependencies
import React from 'react';
import { ThemeContext } from '../../../components/theme/Theme.jsx';
import radium from 'radium';
import Moment from 'react-moment';


function DateTimeLocation(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			margin: '.5em 0 0',
			color: context.themeManager.value('shopping-cart-event-time-location', 'color', 'fg-color-text'),
			fontSize: context.themeManager.value('shopping-cart-event-time-location', 'fontSize', 'font-size-90'),
		},
		date: {
			margin: '0 0 0.1em 0',
			lineHeight: context.themeManager
				.value('shopping-cart-event-date', 'lineHeight', 'line-height-300'),
		},
		location: {
			margin: ' 0 0 0.3em 0',
			lineHeight: context.themeManager
				.value('shopping-cart-event-location', 'lineHeight', 'line-height-300'),
		},
	};
	return (
		<div className="shopping-cart__event-date-venue" style={style.container}>
			<span className="shopping-cart__event-date" style={style.date}>
				<Moment locale="de" format="DD.MM.YYYY HH:mm">{props.date}</Moment>
			</span>, <span className="shopping-cart__event-location" style={style.location}>{props.location}</span>
		</div>
	);
}

export default radium(DateTimeLocation);
